import { render, staticRenderFns } from "./car-archive.vue?vue&type=template&id=64a9951d&scoped=true&"
import script from "./car-archive.vue?vue&type=script&lang=js&"
export * from "./car-archive.vue?vue&type=script&lang=js&"
import style0 from "./car-archive.vue?vue&type=style&index=0&id=64a9951d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9951d",
  null
  
)

export default component.exports